/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreatePluginForm,
  CreatePluginForm$Outbound,
  CreatePluginForm$outboundSchema,
} from "../components/createpluginform.js";

export type CreatePluginSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type CreatePluginRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createPluginForm: CreatePluginForm;
};

/** @internal */
export type CreatePluginSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreatePluginSecurity$outboundSchema: z.ZodMiniType<
  CreatePluginSecurity$Outbound,
  CreatePluginSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createPluginSecurityToJSON(
  createPluginSecurity: CreatePluginSecurity,
): string {
  return JSON.stringify(
    CreatePluginSecurity$outboundSchema.parse(createPluginSecurity),
  );
}

/** @internal */
export type CreatePluginRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreatePluginForm: CreatePluginForm$Outbound;
};

/** @internal */
export const CreatePluginRequest$outboundSchema: z.ZodMiniType<
  CreatePluginRequest$Outbound,
  CreatePluginRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createPluginForm: CreatePluginForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      createPluginForm: "CreatePluginForm",
    });
  }),
);

export function createPluginRequestToJSON(
  createPluginRequest: CreatePluginRequest,
): string {
  return JSON.stringify(
    CreatePluginRequest$outboundSchema.parse(createPluginRequest),
  );
}
